// TODO: Remove this file when we replace Portal Vue with the Vue 3 Teleport component.
// This plugin is needed in the meantime to keep Portal Vue functional.
import PortalVue from 'portal-vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(PortalVue)
})
